import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContactsComponent } from "./contacts.component";
import { InputWrapperModule } from "../input-wrapper/input-wrapper.module";
import { FormsSharedModule } from "@shared/modules/forms-shared.module";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCheckboxModule as MatCheckboxModule } from "@angular/material/legacy-checkbox";
import { MatIconModule } from "@angular/material/icon";
import { SharedModule } from "@shared/shared.module";
import { FlexLayoutModule } from "ngx-flexible-layout";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";

@NgModule({
	declarations: [ContactsComponent],
	imports: [
		CommonModule,
		InputWrapperModule,
		FormsSharedModule,
		MatIconModule,
		MatButtonModule,
		MatCheckboxModule,
		SharedModule,
		FlexLayoutModule,
		MatTooltipModule
	],
	exports: [ContactsComponent]
})
export class ContactsModule {}
